export const setFavicon = (value?: string) => {
  const newIcon = !value
    ? "/favicon.ico"
    : !value.startsWith("/")
      ? `/${value}`
      : value;

  const existing = document.querySelector("link[rel='icon']");
  if (existing) {
    existing.parentNode?.removeChild(existing);
  }

  const link = document.createElement("link");
  link.rel = "icon";
  // Add cache-busting parameter to prevent favicon caching across tabs
  link.href = `${newIcon}?t=${Date.now()}`;
  document.head.appendChild(link);
};
